import { BaseFormControl } from '../BaseFormControl/BaseFormControl';
import { FormControlProps } from './FormControl.types';
import css from './FormControl.module.scss';
import classNames from 'classnames';

/**
 * The form control that ensures specific styling of the grouped form controls.
 *
 * @note This control is what sets the legend for the `Radio` control to display the error color.
 *
 * @param error - {@link RadioFormControlProps.error error} description.
 * @param className - {@link RadioFormControlProps.className className} description.
 * @param children - {@link RadioFormControlProps.children children} description.
 */
const FormControl = ({
    error,
    className,
    children,
}: FormControlProps) => {
    return (
        <BaseFormControl
            classes={{
                root: classNames(css.formControl, className),
            }}
            error={error}
        >
            {children}
        </BaseFormControl>
    );
};

export default FormControl;